import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import Autocomplete from './autocomplete';

class Search extends React.Component {
    static propTypes = {
        method: PropTypes.string.isRequired,
        search_query: PropTypes.string.isRequired,
        selected_item: PropTypes.shape({}),
        highlighted_item: PropTypes.shape({}),
        autocomplete_list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

        force_autocomplete_hide: PropTypes.bool.isRequired,
        is_search_input_focused: PropTypes.bool.isRequired,
        is_mouseover_search: PropTypes.bool.isRequired,

        onItemSelect: PropTypes.func.isRequired,
        onItemHighlight: PropTypes.func.isRequired,
        onSearchQueryChange: PropTypes.func.isRequired,
        onSavedAddressDeleteClick: PropTypes.func.isRequired,

        onInputFocusChange: PropTypes.func.isRequired,
        onMouseEnterChange: PropTypes.func.isRequired,

        t: PropTypes.func.isRequired,
    };

    static defaultProps = {
        selected_item: null,
        highlighted_item: null,
    };

    onSearchQueryChange = e => {
        const { onSearchQueryChange } = this.props;
        onSearchQueryChange(e.target.value);
    };

    onInputKeyDown = event => {
        const key_code = event.keyCode;
        const next = key_code === 40;
        const prev = key_code === 38;
        const enter = key_code === 13;

        if (this.isAutocompleteShowing()) {
            if (enter) {
                event.target.blur();
                const { onItemSelect, highlighted_item } = this.props;
                onItemSelect(highlighted_item);
            } else if (next || prev) {
                this.movePredictionCursor(next);
            }
        }
    };

    isAutocompleteShowing = () => {
        const {
            force_autocomplete_hide,
            is_search_input_focused,
            is_mouseover_search,
            autocomplete_list,
        } = this.props;
        return (
            !force_autocomplete_hide &&
            (is_search_input_focused || is_mouseover_search) &&
            autocomplete_list.length > 0
        );
    };

    movePredictionCursor(next = true) {
        const {
            autocomplete_list: list,
            highlighted_item: current_item,
            onItemHighlight,
        } = this.props;
        const current_index = _.findIndex(list, { id: current_item.id });
        let new_index = current_index + (next ? 1 : -1);

        if (new_index < 0) {
            new_index = list.length - 1;
        } else if (new_index > list.length - 1) {
            new_index = 0;
        }

        onItemHighlight(list[new_index]);
    }

    render() {
        const {
            t,
            method,
            search_query,
            onInputFocusChange,
            autocomplete_list,
            onItemSelect,
            onItemHighlight,
            onSavedAddressDeleteClick,
            selected_item,
            highlighted_item,
            onMouseEnterChange,
        } = this.props;
        return (
            <div
                className="m2g-locations-finder-address-search"
                data-autocomplete-showing={this.isAutocompleteShowing()}
            >
                <div className="m2g-locations-finder-address-search-label">
                    {method === 'pickup' ? t('search') : t('delivery_address')}
                </div>
                <div
                    className="m2g-locations-finder-address-search-input-container m2g-input-container m2g-form-element--full-width"
                    data-icon-before
                    data-icon-after
                >
                    <input
                        className="m2g-locations-finder-address-search-input m2g-input"
                        value={search_query}
                        onKeyDown={this.onInputKeyDown}
                        onChange={this.onSearchQueryChange}
                        onFocus={() => {
                            this.input.select();
                            onInputFocusChange(true);
                        }}
                        onBlur={() => onInputFocusChange(false)}
                        placeholder={
                            method === 'pickup'
                                ? t('search_pickup_placeholder')
                                : t('search_delivery_placeholder')
                        }
                        ref={e => {
                            this.input = e;
                        }}
                    />
                    <span className="m2g-icon m2g-icon--search" data-before />
                    {autocomplete_list.length > 0 && (
                        <span
                            className="m2g-icon m2g-icon--chevron-down"
                            data-after
                        />
                    )}
                </div>
                {this.isAutocompleteShowing() && (
                    <Autocomplete
                        search_query={search_query}
                        show_logo={method === 'delivery'}
                        onItemSelect={onItemSelect}
                        onItemHighlight={onItemHighlight}
                        onSavedAddressDeleteClick={onSavedAddressDeleteClick}
                        selected_item={selected_item}
                        highlighted_item={highlighted_item}
                        list={autocomplete_list}
                        onMouseEnter={() => onMouseEnterChange(true)}
                        onMouseLeave={() => onMouseEnterChange(false)}
                    />
                )}
            </div>
        );
    }
}

export default forwardRefWithTranslation('locations.finder')(Search);
